import Facebook from '@/assets/icons/facebook.svg'
import Instagram from '@/assets/icons/instagram.svg'
import Tweet from '@/assets/icons/tweet.svg'
import { CoinPrices } from '@/types/coin'
import { openPopupWindow } from '@/utils/popupWindow'

export interface ShareModalContentBaseProps {
  socialType: SocialType
  shareType: ShareType
  currentCoinPrices?: CoinPrices
  curTimeRange: string
}
export interface ShareModalContentProps extends Omit<ShareModalContentBaseProps, 'socialType'> {
  contentContainerRef?: React.ForwardedRef<HTMLDivElement>
}

export enum ShareType {
  Chart = 'chart',
  Lion = 'lion',
  Link = 'link',
}

export enum SocialType {
  twitter = 'twitter',
  facebook = 'facebook',
  instagram = 'instagram',
}

export const socialItems = [
  {
    value: SocialType.twitter,
    label: 'X',
    Icon: Tweet,
  },
  {
    value: SocialType.facebook,
    label: 'Facebook',
    Icon: Facebook,
  },
  {
    value: SocialType.instagram,
    label: 'Instagram',
    Icon: Instagram,
  },
]

export function shareLinkToTargetSocial({
  socialType,
  text,
  popupName,
}: {
  socialType: SocialType
  text: string
  popupName: string
}) {
  let socialUrl: string = ''
  let searchParamsName: string = ''
  if (socialType === SocialType.twitter) {
    socialUrl = 'https://twitter.com/intent/tweet'
    searchParamsName = 'text'
  } else if (socialType === SocialType.facebook) {
    socialUrl = 'https://www.facebook.com/sharer.php'
    searchParamsName = 'u'
  }
  if (!socialUrl) return
  const url = new URL(socialUrl)
  url.searchParams.set(searchParamsName, text)
  openPopupWindow(url.toString(), {
    name: popupName,
  })
}

/**
 * fix BM-3572 issues 3
 * If ShareDownloadHelper render in Modal, would make it have scroll bar
 * Should render it in outside by portal
 */
export const SHARE_DOWNLOAD_HELPER_PORTAL_EL_ID = 'share-download-helper-portal'
